import * as React from "react";
import { SVGProps } from "react";

const Idex = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 331 331" {...props}>
    <path
      fill="#662bc9"
      fillRule="evenodd"
      d="M0 0h331v331H0V0z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m74 230.9 3.2 4.1 17.1 22h142.4l20.3-26.1-50.8-65.4 47.7-61.3 3.2-4.1L236.7 74H94.3l-3.2 4.2-17.1 22 50.8 65.4L74 230.9zm61.3-13.1c-4.3 0-6.7-4.9-4-8.3l13.9-17.9 20.3 26.1h-30.2v.1zm67.6-56.5 44.4-57.1H165c-2.7 0-4.2 3.1-2.5 5.2l3 3.8h30.2c4.3 0 6.7 4.9 4 8.3l-13.9 17.9 17.1 21.9zM80.5 100.1l100.1 128.7.7.9c1.6 2.1.1 5.2-2.5 5.2H83.7l14 18H227L94.3 82.3l-13.8 17.8z"
      clipRule="evenodd"
    />
  </svg>
);

export default Idex;
